import type { Variant } from "./types";

export const HEADING_VARIANTS = [
  "displayXL",
  "displayL",
  "displayM",
  "displayS",
  "headlineL",
  "headlineM",
  "headlineS",
  "headlineXS",
] as const;

export const STANDARD_VARIANTS = [
  "titleL",
  "titleM",
  "titleS",
  "titleXS",
  "bodyL",
  "bodyM",
  "bodyS",
  "labelM",
  "labelS",
] as const;

export const VARIANTS = [...HEADING_VARIANTS, ...STANDARD_VARIANTS] as const;
export const DEFAULT_VARIANT = "bodyM" satisfies Variant;

export const FONT_FAMILIES = [
  "OpenSansBold",
  "OpenSansSemiBold",
  "OpenSansItalic",
  "OpenSansSemiBoldItalic",
] as const;

export const BOLD_FONT_FAMILIES = [
  "OpenSansBold",
  "OpenSansSemiBold",
  "OpenSansSemiBoldItalic",
] as const;
